import { call, put, select } from 'redux-saga/effects';
import { ConnectionMediaTokens, RTCClient } from 'utils/webrtc';
import { pong } from 'features/application/actions';
import { sdkMobileMediaTokenUpdated } from 'features/sdk/actions';
import { selectMobileScreenshare } from 'features/sdk/sdkStateSlice';

export function* refreshConnectionMediaTokensSaga(action: ReturnType<typeof pong>) {
  const tokens: ConnectionMediaTokens = {
    publishing: action.payload.publishingMediaToken,
    subscription: action.payload.subscribingMediaToken,
  };

  if (action.payload.publishingMediaToken) {
    const mobileScreenshare: boolean = yield select(selectMobileScreenshare);
    if (mobileScreenshare) {
      yield put(sdkMobileMediaTokenUpdated(action.payload.publishingMediaToken));
    }
  }

  yield call(RTCClient.refreshConnectionMediaTokens, tokens);
}
